import React from 'react';
import PlanActions from './planBox/PlanActions';

const FreePlanModule = ({ openSourceBanner }) =>
  <section className="free-plan-module">
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <div data-plan="free" className="free-plan-outer">
            <div className="free-plan-details">
              <h2>7,000 free active users &<br /> unlimited logins</h2>
              <ul className="feature-list">
                <li className="feature">
                  <a href="/passwordless" target="_blank">Passwordless & TouchID Login</a>
                </li>
                <li className="feature">
                  <a href="/lock" target="_blank">Lock for Web, iOS & Android</a>
                </li>
                <li className="feature">
                  <a href="/docs/identityproviders" target="_blank">
                    Up to 2 social identity providers
                  </a>
                </li>
                <li className="feature">
                  <a href="https://webtask.io/" target="_blank">Rules & Webtask.io subscription</a>
                </li>
                <li className="feature">
                  <a href="https://community.auth0.com/" target="_blank">Community Support</a>
                </li>
              </ul>
            </div>
            <div className="free-plan-price">
              <div className="price-header">START ON OUR FREE PLAN</div>
              <div className="price-body">
                <h2 className="price-tag">
                  <span className="money-sign">$</span>
                  <span data-price-tag="" className="price-amount">0</span>
                  <span data-time-period="" className="price-time">/mo</span>
                </h2>
                <PlanActions button={{ text: 'Start Now' }} />
                <p className="price-disclaimer">No credit card required</p>
              </div>
            </div>
          </div>
          {openSourceBanner &&
            <div className="open-source-banner">
              <p>
                Have an open source project? Get Auth0 for free with our&nbsp;<span
                  data-toggle="tooltip"
                  data-placement="bottom"
                  data-container="body"
                  title="Are you building an open source project that is completely non-profit? If you add an attribution badge on your website, you and your collaborators can use all the Auth0 features without limits!"
                  className="only-tooltip"
                >
                  <span className="tip-text">Open Source Program</span><span className="tip-icon" />
                </span>
                <a className="open-contact-oss">Learn More</a>
              </p>
            </div>}
        </div>
      </div>
    </div>
  </section>;

export default FreePlanModule;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/FreePlanModule.js